import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export default function useFileDownloader({ file, getSignedUrl, queryKey }) {
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const handleDownload = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { signedUrl } = await queryClient.fetchQuery({
        queryKey: [queryKey, { id: file.id }],
        queryFn: () => getSignedUrl(file.id),
      });
      window.open(signedUrl, '_blank');
    } catch (e) {
      // Ignore error
    }
    setLoading(false);
  }, [queryClient, file.id, file.originalname, loading]);

  return { handleDownload, loading };
}
